export enum CustomFieldDataTypeEnum {
  String = 'String',
  Integer = 'Integer',
  Decimal = 'Decimal',
  Date = 'Date',
}
